var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cashier-desk",
      class: { "in-pos": _vm.$route.path === "/pos" },
    },
    [
      _c("top-bar", {
        on: {
          hang: _vm.hangOrder,
          take: function ($event) {
            _vm.takeVisible = true
          },
          return: function ($event) {
            _vm.returnVisible = true
          },
          shift: function ($event) {
            _vm.shiftVisible = true
          },
          lock: function ($event) {
            _vm.locked = true
          },
          screen: _vm.openCustomerScreen,
        },
      }),
      _c(
        "div",
        { staticClass: "desk-top" },
        [
          _c("member-bar", {
            ref: "memberBar",
            attrs: { member: _vm.member },
            on: { located: _vm.onMemberLocated, clear: _vm.onMemberClear },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "desk-main" }, [
        _c(
          "div",
          { staticClass: "desk-left" },
          [
            _c("search-box", {
              ref: "searchBox",
              attrs: { levelId: _vm.member ? _vm.member.levelId : null },
              on: {
                "pick-goods": _vm.onSearchPick,
                "pick-member": _vm.onMemberLocated,
                "scan-order": _vm.verifyOrderQr,
              },
            }),
            _c("category-chips", {
              attrs: {
                categories: _vm.categories,
                activeId: _vm.activeCategoryId,
                activeChildId: _vm.activeChildId,
              },
              on: {
                select: _vm.onCategorySelect,
                "select-child": _vm.onChildCategorySelect,
              },
            }),
            _c(
              "div",
              { staticClass: "goods-area" },
              [
                _c("goods-grid", {
                  attrs: { rows: _vm.goodsRows },
                  on: { pick: _vm.onGoodsPick },
                }),
                _c(
                  "div",
                  { staticClass: "goods-more" },
                  [
                    _vm.hasMore
                      ? _c(
                          "a-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.loadMore },
                          },
                          [_vm._v("加载更多")]
                        )
                      : _c("span", { staticClass: "goods-end" }, [
                          _vm._v("共 " + _vm._s(_vm.total) + " 个商品"),
                        ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "desk-right" },
          [
            _c("cart-panel", {
              attrs: { items: _vm.cart, member: _vm.member },
              on: {
                change: _vm.onItemChange,
                changePrice: _vm.onItemPriceChange,
                remove: _vm.onItemRemove,
                clear: _vm.onCartClear,
                settle: _vm.openPay,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "desk-depot" },
        [
          _vm._v("\n    仓库：\n    "),
          _c(
            "a-select",
            {
              staticStyle: { width: "160px" },
              attrs: { size: "small" },
              model: {
                value: _vm.depotId,
                callback: function ($$v) {
                  _vm.depotId = $$v
                },
                expression: "depotId",
              },
            },
            _vm._l(_vm.depots, function (d) {
              return _c(
                "a-select-option",
                { key: d.id, attrs: { value: d.id } },
                [_vm._v(_vm._s(d.name))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("spec-select-modal", {
        attrs: { visible: _vm.specVisible, goods: _vm.specGoods },
        on: {
          ok: _vm.onSpecPick,
          cancel: function ($event) {
            _vm.specVisible = false
          },
        },
      }),
      _c("pay-modal", {
        ref: "payModal",
        attrs: {
          visible: _vm.payVisible,
          total: _vm.cartTotal,
          loading: _vm.settling,
          "pay-qr": _vm.payQr,
        },
        on: {
          ok: _vm.onSettle,
          cancel: _vm.onPayCancel,
          "create-qrcode": _vm.onCreateQrcode,
        },
      }),
      _c("receipt-done", {
        attrs: { visible: _vm.doneVisible, result: _vm.settleResult },
        on: { next: _vm.onNextOrder },
      }),
      _c("return-modal", {
        attrs: { visible: _vm.returnVisible },
        on: {
          cancel: function ($event) {
            _vm.returnVisible = false
          },
          done: function ($event) {
            return _vm.loadGoods(1, true)
          },
        },
      }),
      _c("shift-modal", {
        attrs: { visible: _vm.shiftVisible },
        on: {
          cancel: function ($event) {
            _vm.shiftVisible = false
          },
        },
      }),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.takeVisible,
            title: "取单（F3）",
            footer: null,
            width: "560px",
          },
          on: {
            cancel: function ($event) {
              _vm.takeVisible = false
            },
          },
        },
        [
          !_vm.pendingOrders.length
            ? _c("div", { staticClass: "pending-empty" }, [_vm._v("暂无挂单")])
            : _vm._e(),
          _vm._l(_vm.pendingOrders, function (order) {
            return _c("div", { key: order.id, staticClass: "pending-card" }, [
              _c("div", { staticClass: "pending-line" }, [
                _c("span", { staticClass: "pending-no" }, [
                  _vm._v(_vm._s(order.no)),
                ]),
                _c("span", { staticClass: "pending-member" }, [
                  _vm._v(
                    _vm._s(
                      order.member
                        ? order.member.contacts || order.member.cardNo
                        : "散客"
                    )
                  ),
                ]),
                _c("span", { staticClass: "pending-amount" }, [
                  _vm._v("¥" + _vm._s(order.total.toFixed(2))),
                ]),
              ]),
              _c("div", { staticClass: "pending-line sub" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(order.time) + " · " + _vm._s(order.count) + " 件"
                  ),
                ]),
                _c(
                  "span",
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.takeOrder(order)
                          },
                        },
                      },
                      [_vm._v("取单")]
                    ),
                    _c(
                      "a-button",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.removePending(order)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _c("lock-screen", {
        attrs: { visible: _vm.locked },
        on: {
          unlock: function ($event) {
            _vm.locked = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }